import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";

import { Markup } from "interweave";
import moment from "moment";
import { Link, useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import fan from "../../../../../../assets/images/fanGroup/Maskgroup.png";
import flag from "../../../../../../assets/images/flag.png";
import FanGroupIcon from "../../../../../../assets/images/iconFan/expired-1.png";
import flag1 from "../../../../../../assets/images/Registration-End-01.1.png";
import noImage from "../../../../../../../src/assets/images/settings/no-image.png";
import "./PendingFanGroup.css";
import { serverInfo } from "../../../../../../App";
import { useContext } from "react";
const PendingGroup = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  let history = useHistory();
  const { slug } = useParams();

  // const handleClick = () => {
  //   history.push("/superstar-admin/pending-fan-group-competition");
  // };

  const [fanDetails, setFanDetails] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setFanDetails(res.data?.fanDetails);
      }
    });
  }, [slug]);

  const deleteFanGroup = async (e) => {
    e.preventDefault();

    axios.delete(`/api/admin/fan/group/delete/${slug}`).then((res) => {
      if (res.status === 200) {
        swal("Welcome", res.data.message, "success");
        history.push("/superstar-admin/fan-group");
      }
    });
  };
  
  const handleDone = () => {
    axios.post(`/api/admin/fan-group/manager/approval/${slug}`).then((res) => {
      if (res.data.status === 200) {
        swal("Welcome", res.data.message, "success");
      }
    });
  };

  return (
    <div className="mx-2 card bg-black p-3 px-4">
      <div className="d-flex my-2">
        <img className="img-fluid" width="35px" src={FanGroupIcon} alt="" />
        <h3 className="text-white mx-2">Pending Fan Group</h3>
      </div>

      <div className="row">
        <div className="col-md-12 card card-bg p-0 fanPo rounded-3 border-warning">
          <img src={fan} alt="" style={{ minHeight: 200 }} />
          <div className="fanpso fanGroupText">
            <h4 className="pendingTxt">PENDING</h4>
            <h2 className="fanGroupTxt">FAN GROUP</h2>
          </div>
        </div>
      </div>

      <div className="row my-4">
        <div className="col-md-7 text-light ">
          <h2 className="titleFanName">{fanDetails.group_name}</h2>
          <p>
            <Markup content={fanDetails.description} />
          </p>
        </div>
        <div className="col-md-5">
          <div className="row registration-body  card-bg m-0 pt-3">
            <div className="col-md-12 m-0 ">
              <div className="d-flex registration-btn p-2">
                <div className="mx-3 mt-2">
                  <span className="text-light">
                    <img src={flag} alt="" className="PriceTage" />
                  </span>
                </div>
                <div className=" mx-1">
                  <span className="text-light">Estimation Start:</span>
                  <br></br>
                  <span className=" text-warning fw-bold">
                    {moment(fanDetails.start_date).format("LL")}
                    {/* 24 July, 2022 */}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-12 m-0 ">
              <div className="d-flex registration-btn p-2">
                <div className="mx-3 mt-2">
                  <span className="text-light">
                    <img src={flag1} alt="" className="PriceTage" />
                  </span>
                </div>
                <div className=" mx-1">
                  <span className="text-light">Estimation End:</span>
                  <br></br>

                  <span className=" text-warning fw-bold">
                    {moment(fanDetails.end_date).format("LL")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row my-4">
        <div className="col-md-7 mb-3 row d-flex justify-content-center">
          <div className="col-md-6 mb-2">
            <div className="card card-bg snip1527">
              <img
                className="shakibAdminImg img-fluid"
                src={
                  fanDetails?.my_superstar?.image
                    ? imageCdnUrl + fanDetails?.my_superstar?.image
                    : noImage
                }
                alt="pr-sample23"
              />
              <figcaption>
                <h3>
                  {fanDetails.my_superstar?.first_name}{" "}
                  {fanDetails.my_superstar?.last_name}
                </h3>

                <p>
                  <big>
                    <span className="text-light">Status</span>:{" "}
                    {Number(fanDetails.my_star_status) === 1 ? (
                      <i className="text-warning fw-bold">Accepted</i>
                    ) : Number(fanDetails.my_star_status) === 2 ? (
                      <i className="text-warning fw-bold">Ignored</i>
                    ) : (
                      <i className="text-warning">Pending</i>
                    )}
                  </big>
                </p>
                <button className="btn btn-info w-100 mt-2">
                  Render Group
                </button>
              </figcaption>
            </div>
          </div>

          <div className="col-md-6 mb-2">
            <div className="card card-bg snip1527">
              <img
                className="shakibAdminImg img-fluid"
                src={
                  fanDetails.another_superstar?.image
                    ? imageCdnUrl + fanDetails.another_superstar?.image
                    : noImage
                }
                alt="pr-sample23"
              />
              <figcaption>
                <h3>
                  {fanDetails.another_superstar?.first_name}{" "}
                  {fanDetails.another_superstar?.last_name}
                </h3>

                <p>
                  <big>
                    <span className="text-light">Status</span>:{" "}
                    {Number(fanDetails.another_star_status) === 1 ? (
                      <i className="text-warning">Accepted</i>
                    ) : Number(fanDetails.another_star_status) === 2 ? (
                      <i className="text-warning">Ignored</i>
                    ) : (
                      <i className="text-warning fw-bold">Pending</i>
                    )}
                  </big>
                </p>
                <button className="btn btn-info w-100 mt-2">
                  Render Group
                </button>
              </figcaption>
            </div>
          </div>
        </div>

        <div className="col-md-5 d-flex justify-content-center align-items-center">
          <div>
            <h3 className="text-light text-center my-3">
              <i className="fw-bolder">Status</i>
            </h3>
            <div className="d-flex justify-content-center align-items-center ">
              {Number(fanDetails.my_star_status) === 0 &&
              Number(fanDetails.another_star_status) === 0 ? (
                <div style={{ width: 240 }}>
                  <CircularProgressbarWithChildren
                    value={0}
                    styles={buildStyles({
                      pathColor: `gold`,
                    })}
                  >
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <strong className="text-light">0% complete</strong>
                    </div>
                  </CircularProgressbarWithChildren>
                </div>
              ) : (
                ""
              )}

              {(Number(fanDetails.my_star_status) === 1 ||
                Number(fanDetails.my_star_status) === 2) &&
              Number(fanDetails.another_star_status) === 0 ? (
                <div style={{ width: 240 }}>
                  <CircularProgressbarWithChildren
                    value={50}
                    styles={buildStyles({
                      pathColor: `gold`,
                    })}
                  >
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <strong className="text-light">50% complete</strong>
                    </div>
                  </CircularProgressbarWithChildren>
                  <p className="text-warning text-center my-2">
                    {Number(fanDetails.my_star_status) === 1
                      ? "Approved"
                      : "Ignored"}{" "}
                    by{" "}
                    <span className="fw-bolder textFontA">
                      {fanDetails.my_superstar?.first_name}{" "}
                      {fanDetails.my_superstar?.last_name}
                    </span>
                  </p>
                </div>
              ) : (
                ""
              )}

              {(Number(fanDetails.another_star_status) === 1 ||
                Number(fanDetails.another_star_status) === 2) &&
              Number(fanDetails.my_star_status) === 0 ? (
                <div style={{ width: 240 }}>
                  <CircularProgressbarWithChildren
                    value={50}
                    styles={buildStyles({
                      pathColor: `gold`,
                    })}
                  >
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <strong className="text-light">50% complete</strong>
                    </div>
                  </CircularProgressbarWithChildren>
                  <p className="text-warning text-center my-2">
                    {Number(fanDetails.another_star_status) === 1
                      ? "Approved"
                      : "Ignored"}{" "}
                    by{" "}
                    <span className="textFontB">
                      {fanDetails.another_superstar?.first_name}{" "}
                      {fanDetails.another_superstar?.last_name}
                    </span>
                  </p>
                </div>
              ) : (
                ""
              )}

              {(Number(fanDetails.another_star_status) === 1 ||
                Number(fanDetails.another_star_status) === 2) &&
              (Number(fanDetails.my_star_status) === 1 ||
                Number(fanDetails.my_star_status) === 2) &&
              Number(fanDetails.status) === 2 ? (
                <div className="bg-dark bgBorderManagerAuth py-2 px-5 d-flex">
                  {/* <div className="spinnerBootstrap">
                    <div className="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div> */}
                  <div class="center d-flex">
                    <div class="parent-spinner">
                      <div
                        class="spinner spinner-rotate border-spinner-yellow"
                        data-mx-time="0.6"
                      ></div>
                    </div>
                  </div>

                  <div className="ps-4">
                    <p className="text-light">Manager Authentication</p>
                    <h3 className="text-warning">Waiting</h3>
                  </div>
                </div>
              ) : (Number(fanDetails.another_star_status) === 1 ||
                  Number(fanDetails.another_star_status) === 2) &&
                (Number(fanDetails.my_star_status) === 1 ||
                  Number(fanDetails.my_star_status) === 2) ? (
                <div style={{ width: 240 }}>
                  <CircularProgressbarWithChildren
                    value={100}
                    styles={buildStyles({
                      pathColor: `gold`,
                    })}
                  >
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <strong className="text-light">100% complete</strong>
                    </div>
                  </CircularProgressbarWithChildren>
                  <p className="text-warning text-center my-2">
                    {Number(fanDetails.my_star_status) === 1
                      ? "Approved"
                      : "Ignored"}{" "}
                    by{" "}
                    <span className="fw-bolder textFontA">
                      {fanDetails.my_superstar?.first_name}{" "}
                      {fanDetails.my_superstar?.last_name}
                    </span>{" "}
                    &{" "}
                    {Number(fanDetails.another_star_status) === 1
                      ? "Approved"
                      : "Ignored"}{" "}
                    by{" "}
                    <span className="fw-bolder textFontB">
                      {fanDetails.another_superstar?.first_name}{" "}
                      {fanDetails.another_superstar?.last_name}
                    </span>
                  </p>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row my-3">
        <div className="col-md-7 row">
          <div className="col-sm-12 col-md-6 col-lg-3">
            <button
              className="btn w-100 btn-danger text-light fw-bold mb-3"
              onClick={deleteFanGroup}
            >
              Delete
            </button>
          </div>

          {Number(fanDetails.another_star_status) < 1 &&
          Number(fanDetails.my_star_status) < 1 ? (
            <div className="col-sm-12 col-md-6 col-lg-3">
              <Link
                to={`/superstar-admin/pending-fan-group-Edit/${slug}`}
              >
                <button className="btn w-100 btnUpdate mb-3 text-dark fw-bold">
                  Edit
                </button>
              </Link>
            </div>
          ) : (
            <></>
          )}

          <div className="col-sm-12 col-md-6 col-lg-3">
            <Link
              to={`/superstar-admin/pending-fan-group-competition/${slug}`}
            >
              {Number(fanDetails.another_star_status) === 1 &&
              Number(fanDetails.my_star_status) === 1 &&
              Number(fanDetails.status) === 0 ? (
                <button
                  className="btn btnCreate w-100 fw-bold"
                  onClick={handleDone}
                >
                  {" "}
                  <i className="fa fa-angles-right"></i> Forward Manager
                </button>
              ) : (
                ""
              )}
              {Number(fanDetails.status) === 1 ? (
                <button className="btn btnCreate w-100 fw-bold">
                  {" "}
                  <i className="fa fa-angles-left"></i> Approved{" "}
                </button>
              ) : (
                ""
              )}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingGroup;
